import { Children, cloneElement } from 'react';

export function OfferFormContainer({ children, ...props }) {
  return Children.only(cloneElement(children, { ...props }));
}
